module.exports = __webpack_public_path__ + "img/ese.d139284e.png";